var map = {
	"./LV0.png": "jTCl",
	"./LV1.png": "0CCf",
	"./LV2.png": "m2V+",
	"./LV3.png": "6+dF",
	"./LV4.png": "eNmy",
	"./LV5.png": "8V1u",
	"./LV6.png": "yS48",
	"./LV7.png": "em4K"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "gldy";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/level ^\.\/LV.*\.png$
// module id = gldy
// module chunks = 2